import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-21-arun-vinayak-guest.webp";
import ThumbImg from "../../assets/images/conversations/021.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: av2-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .av2-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .av2-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ── HERO ── */
  .av2-hero { padding-top: 60px; padding-bottom: 60px; }
  .av2-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .av2-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .av2-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .av2-hero__title.av2-visible { opacity: 1; transform: translateY(0); }
  .av2-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .av2-hero__spotify.av2-visible { opacity: 1; transform: translateY(0); }
  .av2-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .av2-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .av2-hero__right.av2-visible { opacity: 1; transform: translateY(0); }

  /* ── YOUTUBE THUMB ── */
  .av2-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .av2-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .av2-yt-thumb:hover img { opacity: 0.85; }
  .av2-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .av2-yt-thumb__play img { width: 40px; height: 44px; }
  .av2-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .av2-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ── BODY ── */
  .av2-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .av2-body.av2-visible { opacity: 1; transform: translateY(0); }
  .av2-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .av2-body__para:last-child { margin-bottom: 0; }

  /* ── GUEST ── */
  .av2-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .av2-guest.av2-visible { opacity: 1; transform: translateY(0); }
  .av2-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .av2-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .av2-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .av2-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .av2-inner { padding-left: 32px; padding-right: 32px; }
    .av2-hero { padding-top: 32px; padding-bottom: 48px; }
    .av2-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .av2-hero__title { font-size: 24px; }
    .av2-hero__left { gap: 16px; }
    .av2-guest__title { font-size: 24px; margin-bottom: 24px; }
    .av2-guest__photo-bg { width: 260px; height: 300px; }
    .av2-guest__name { font-size: 24px; margin-top: 18px; }
    .av2-body__para { font-size: 14px; margin-bottom: 12px; }
    .av2-body { padding-bottom: 48px; }
    .av2-guest { padding-bottom: 48px; }
    .av2-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .av2-inner { padding-left: 16px; padding-right: 16px; }
    .av2-hero { padding-top: 51px; padding-bottom: 30px; }
    .av2-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .av2-hero__left { gap: 30px; }
    .av2-hero__title { font-size: 30px; }
    .av2-body__para { font-size: 16px; margin-bottom: 10px; }
    .av2-guest__title { font-size: 30px; margin-bottom: 20px; text-align:left;}
    .av2-guest__photo-bg { width: 100%; height: 386px; }
    .av2-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .av2-body { padding-bottom: 30px; }
    .av2-guest { padding-bottom: 30px; }
    .av2-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("av2-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "2oFLxzBNxC8";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="av2-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 21 Arun Vinayak Exponent Energy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div
      className="av2-yt-thumb"
      onClick={() => setPlaying(true)}
      role="button"
      aria-label="Play video"
    >
      <img src={ThumbImg} alt="EP 21 Arun Vinayak thumbnail" />
      <div className="av2-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="av2-hero">
      <div className="av2-inner">
        <div className="av2-hero__grid">
          <div className="av2-hero__left">
            <h1 ref={titleRef} className="av2-hero__title">
              EP 21 | Achieving the impossible – Rapid Charge in 15 minutes | Arun Vinayak | Exponent Energy
            </h1>
            <div ref={spotifyRef} className="av2-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/2eqrJWhAJ0YwOvbZdTOS9y?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 21 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="av2-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="av2-body">
      <div className="av2-inner">
        <p className="av2-body__para">
          During the last 18 months on this program, we have covered conversations with the entire EV ecosystem in India including regulators, grid operators, vehicle manufacturers, battery manufacturers and charge point operators. What has become a very evident lesson is that the various elements of the EV ecosystem dance to their own tune and are not yet at the point of working in cohesion and mostly prefer to do their own thing. For example, the reason it takes a long to charge an EV today is because we need the battery manufacturer, BMS software developers, vehicle OEMs and charging manufacturers to all dance together in a delicate symphony in order to design a vehicle powered with batteries and managed by BMS that would safely take hypercharge or supercharge.
        </p>
        <p className="av2-body__para">
          How far away are we from this reality today? It is a very unique problem and this problem is exactly what Bangalore based start-up Exponent Energy is furiously working to address. We speak today on the very same subject with the Co-founder Arun Vinayak.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="av2-guest">
      <div className="av2-inner">
        <h2 className="av2-guest__title">Our Guest</h2>
        <div>
          <div className="av2-guest__photo-bg">
            <img src={GuestImg} alt="Arun Vinayak" />
          </div>
          <p className="av2-guest__name">Arun VINAYAK</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep21ArunVinayak() {
  return (
    <>
      <style>{CSS}</style>
      <div className="av2-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}